import { BaseList } from "App/Screens/SubModules/Component";
import descriptor from "./descriptorOffline";

class MappingModeList extends BaseList {
  constructor(props) {
    super(props)

    this.appName = 'merchant'
    this.modelName = 'mappingmode'
    this.propsList = {
      avatar: 'name',
      pageTitle: 'Mapping Mode',
      descriptor,
      masterKey: 'module-merchant-mappingMode',
    }
  }
}

export default MappingModeList